export default "__VITE_ASSET__BFFcKE7Z__"